<template>
    <div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">

                <div class="ml-auto text-right mb-3">
                    <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                        :data="exportData"
                        :fields="exportFields"
                        :header="exportHeaders"
                        type="csv"
                        :escapeCsv="false"
                        :name="exportFileName">
                        <span>CSV</span>
                    </exportCSV>
                </div>

                <div class="row">

                    <div v-show="false" class="col-sm-12 col-md-4 mb-2 align-items-center justify-content-start">
                        <div class="dataTables_filter mb-2">
                            <label class="d-flex mb-0">
                                <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                    :placeholder="$t('label.search')" v-model="filterSearch" @keypress.enter="filterBySearch">
                                <button
                                    class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                                    @click="filterBySearch()">
                                    <i class="fas fa-search"></i>
                                </button>
                            </label>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4 mb-2">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label
                                        class="input-group-text border-right-0"
                                        for="serviceCategory">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect
                                        :value="filterOutlet"
                                        label="text"
                                        track-by="id"
                                        :options="outlets"
                                        :searchable="false"
                                        :show-labels="false"
                                        openDirection="below"
                                        @select="filterByOutlet">
                                        <template
                                            slot="option"
                                            slot-scope="{ option }">{{ option.text }}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-show="false" v-if="selectedTab === 'list'" class="col-sm-12 col-md-4 mb-2">
                        <date-range-picker
                            class="w-100"
                            ref="picker"
                            v-model="filterDate"
                            :opens="'right'"
                            :autoApply="true"
                            :showDropdowns="true"
                            :always-show-calendars="true"
                            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                            @showCustomRange="showCustomRangeCalendars = true"
                            @update="filterByDate">
                        </date-range-picker>
                    </div>

                </div>

                <div v-show="false" class="row">
                    <div class="mt-3 col-md-6 col-lg-6 col-xl-4 d-flex flex-column">
                        <b-button-group size="sm">
                            <b-button
                                v-for="tab of statusTabs"
                                :key="'statusTabs_' + tab.value"
                                variant="outline-primary"
                                :class="filterStatus === tab.value ? 'active' : ''"
                                @click="filterStatus = tab.value">
                                {{ tab.text }}
                            </b-button>
                        </b-button-group>
                    </div>
                </div>

                <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="custom-control-input" id="showEnabled" v-model="filterEnable">
                    <label class="custom-control-label" for="showEnabled">{{$t('label.show_enable')}}</label>
                </div>

                <a class="link text-primary" @click="clearFilter">{{ $t('button_link.clear_filter') }}</a>
            </div>
            <div class="panel-container">
                <div class="panel-content">
                    <div v-if="showSpinner" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>

                    <div class="panel-tag mt-3" v-if="!showSpinner && totalEntries == 0 && selectedTab === 'list'">{{ $t('table.no_records') }}</div>

                    <div class="dataTables_wrapper dt-bootstrap4" v-if="!showSpinner && totalEntries != 0 && selectedTab === 'list'">
                        <div v-if="showPagination" class="row justify-content-end mt-2">
                            <div class="col-auto pt-2">
                                <span>{{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}</span>
                            </div>
                            <div class="col-auto">
                                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                    @input="handlePagination"></b-pagination>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table striped hover :fields="fields" :items="data" responsive>
                                    <template #cell(index)="data">
                                        {{ data.index + startPage }}
                                    </template>
                                    <template #cell(name)="data">
                                        {{ data.item.name }}
                                    </template>
                                    <template #cell(outlet)="data">
                                        {{ getOutlet(data.item.outletID) }}
                                    </template>
                                    <template #cell(location)="data">
                                        {{ data.item.outlet_city }}
                                    </template>
                                    <template #cell(disable)="data">
                                        <span class="badge" :class="data.item.disableDate ? 'badge-secondary' : 'badge-primary'">{{data.item.disableDate ? $t('table.value.disable') : $t('table.value.enable')}}</span>
                                    </template>
                                    <template #cell(action)="data">
                                        <b-button @click="showModalEdit(data.item)" tabindex="0" variant="outline-primary">
                                            <i class="fal fa-pencil fs-xl"></i>
                                        </b-button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { handleSessionExpired, setReturnData, getMemberMap } from './../../../../assets/js/dashboard/dashboard.js'
import { all } from 'q'
import DateRangePicker from 'vue2-daterange-picker'

export default {
    name: 'roomList',
    props: {
        outlets: {
            type: Array,
            default(rawProps) {
                return []
            },
        },
        selectedTab: {
            type: String,
            default(rawProps) {
                return 'list'
            },
        },
    },
    components: {
        DateRangePicker,
    },
    data() {
        let startDate = moment().startOf('month').toDate()
        let endDate = moment().endOf('month').toDate()

        return {
            statusTabs: [
                { text: 'All', value: 'all' },
                { text: 'Pending', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                { text: 'Rejected', value: 'rejected' },
            ],
            showSpinner: false,
            showPagination: true,

            filterStatus: "all",
            filterSearch: "",
            filterOutlet: { id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) },
            filterDate: { startDate, endDate },
            filterEnable: true,
            calendarDate: { startDate, endDate },

            data: [],

            currentPage: 1,
            totalEntries: 0,
            totalPage: 0,
            startPage: 1,
            endPage: 0,
            perPage: 100,

            exportHeaders: [],
            exportData: [],
            exportFields: {},
            exportFileName: "",
        }
    },
    computed: {
        fields() {
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "name", label: "Name", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "outlet", label: "Outlet", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "location", label: "Location", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "disable", label: "Enabled/Disabled", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "action", label: 'Actions', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
            ]
        },
    },
    watch: {
        "$i18n.locale"(val) {
            this.setExportData(this.exportData)
        },
        filterStatus(value) {
            this.loadData()
        },
        filterEnable(value) {
            this.filterEnable = value
            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },
        // outlets(val) {
        //     if (!this.filterOutlet) {
        //         this.filterOutlet = val[0]
        //         this.loadData();
        //     }
        // },
        selectedTab(val) {
            this.$nextTick(() => {
                this.page = 0;
                this.currentPage = 1;
                this.loadData();
                // if(this.$refs['calendar']) {
                //     this.$refs['calendar'].setData(this.data)
                // }
            })
        },
    },
    methods: {
        getMemberImage(img) {
            return img;
        },
        getDate(date) {
            if (!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('ddd, DD/MM/YYYY')
        },
        getTime(date) {
            if (!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('hh:mmA')
        },
        getDateTime(date) {
            if (!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('DD/MM/YYYY HH:mm:ss')
        },
        getDate2(date) {
            if (!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('DD/MM/YYYY')
        },
        getOutlet(outletID) {
            return (this.outlets.find(k => k['id'] === outletID) || {}).text || ''
        },

        clearFilter() {
            this.filterOutlet = this.outlets[0]
            this.filterStatus = 'all'
            this.filterSearch = ""
            this.loadData();
        },
        filterBySearch() {
            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },
        filterByOutlet(val) {
            this.filterOutlet = val
            this.$emit('onOutletChange', val)

            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },
        filterByDate() {
            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },

        handlePagination(pg) {
            if (pg != null) {
                this.currentPage = pg;
                this.startPage = ((pg - 1) * 100) + 1;
                this.endPage = pg * 100;
                if (this.endPage > this.totalEntries) {
                    this.endPage = this.totalEntries;
                }
            }
        },

        async loadData() {
            this.showSpinner = true
            this.loadDataImpl(this.selectedTab === 'list')
        },
        async loadDataImpl(paging) {
            let url = 'https://staff.tunai.io/business/room'

            if(this.selectedTab === 'list') {
                url += '?start=' + (this.filterDate.startDate.getTime() / 1000) + '&stop=' + (this.filterDate.endDate.getTime() / 1000)
            } else {
                url += '?start=' + (this.calendarDate.startDate.getTime() / 1000) + '&stop=' + (this.calendarDate.endDate.getTime() / 1000)
            }

            if (paging) {
                url += '&page=' + (this.currentPage - 1)
            }

            if (this.filterOutlet.id !== 'all') {
                url += '&outletID=' + this.filterOutlet.id
            }

            if (this.filterSearch) {
                url += '&search=' + this.filterSearch
            }

            if (this.filterStatus !== 'all') {
                url += '&status=' + this.filterStatus
            }

            if(this.filterEnable) {
                url += '&disable=' + 0
            }

            await this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() },
            })
                .then((response) => {
                    let result = this.data = response.data['rooms']

                    var retData = setReturnData(result, result.length, this.currentPage - 1);
                    this.totalEntries = result.length;
                    this.totalPage = retData.totalPage;
                    this.startPage = retData.startPage;
                    this.endPage = retData.endPage;

                    this.showSpinner = false;

                    if (paging) {
                        if (response.data.count > 100) {
                            this.loadDataImpl(false)
                        } else {
                            if (this.$refs['calendar']) {
                                this.$refs['calendar'].setData(result)
                            }
                            this.setExportData(result)
                        }
                    } else {
                        if (this.$refs['calendar']) {
                            this.$refs['calendar'].setData(result)
                        }
                        this.setExportData(result)
                    }
                })
                .catch((err) => {
                    console.log(err)
                    if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                        return
                    }

                    this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
                })
        },

        setExportData(temp) {
            this.exportFields = {}
            this.exportFields["#"] = "index";
            this.exportFields['Name'] = "name"
            this.exportFields['Outlet'] = "outlet"
            this.exportFields['Location'] = "location"
            this.exportFields['Enabled/Disabled'] = "disable"

            this.exportData = [];
            for (var i = 0; i < temp.length; i++) {
                var data = {}
                data["index"] = i + 1;
                data["name"] = temp[i].name
                data["outlet"] = this.getOutlet(temp[i].outletID)
                data["location"] = temp[i].outlet_city
                data["disable"] = temp[i].disableDate ? 'Disabled' : 'Enabled'
                this.exportData.push(data)
            }

            var type = this.statusTabs.find(k => k['value'] === this.filterStatus)
            let header = this.$msg.REPORT.HEADER + 'Room' + " (" + type.text + ")"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), " "];
            this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV
        },

        showModalAdd(date) {
            this.$emit('addData', date)
        },
        showModalEdit(item) {
            this.$emit('editData', item)
        },
    },
    async mounted() {
        this.loadData()
    }
}
</script>
<style scoped>
.link,
.nav-link {
    cursor: pointer;
}
</style>